import './App.css';
import HomePage from "./components/HomePage";
import InstallPage from "./components/InstallPage";
import EnrollPage from "./components/EnrollPage";
import DownloadPage from "./components/DownloadPage";
import AboutPage from "./components/AboutPage";
import SupportPage from "./components/SupportPage";
import Header from "./components/Header";
import LegalDocs from "./components/LegalDocs";
import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import BetaAgreement from "./components/BetaAgreement";
import FAQPage from "./components/FAQPage";
import StoryworthAlternative from "./components/StoryworthAlternative";
import SelfiePage from "./components/SelfiePage";
import { Route, Routes } from "react-router-dom";
import Footer from "./components/Footer";


function App() {
  return (
    <div className="d-flex flex-column" style={{ minHeight: '100vh' }}>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/npr/*" element={<HomePage />} />
          <Route path="/enroll" element={<EnrollPage />} />
          <Route path="/install" element={<InstallPage />} />
          <Route path="/install/actual" element={<DownloadPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/compare/storyworth" element={<StoryworthAlternative />} />
          <Route path="/selfie" element={<SelfiePage />} />
          <Route path="/legalDocs" element={<LegalDocs />} />
          <Route path="/legalDocs/TermsAndConditions" element={<TermsAndConditions />} />
          <Route path="/legalDocs/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/legalDocs/BetaAgreement" element={<BetaAgreement />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
